import SpriteSymbol from "../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-unselected",
  "use": "icon-unselected-usage",
  "viewBox": "0 0 54 54",
  "content": "<symbol viewBox=\"0 0 54 54\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-unselected\">\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M54 27C54 12.0883 41.9117 0 27 0C12.0883 0 0 12.0883 0 27C0 41.9117 12.0883 54 27 54C41.9117 54 54 41.9117 54 27ZM6 27C6 15.402 15.402 6 27 6C38.598 6 48 15.402 48 27C48 38.598 38.598 48 27 48C15.402 48 6 38.598 6 27Z\" fill=\"#E5E5E5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol